const getVariantFacetName = (variant, productType)=>{
    if (productType === 'Frames' || productType === 'Sunglasses') {
        var ref;
        const frameColor = (ref = variant.frame) === null || ref === void 0 ? void 0 : ref.color.localized;
        const lensColor = variant.lensColor;
        return !lensColor ? frameColor : `${lensColor} / ${frameColor}`;
    }
    if (productType === 'Accessories') {
        var ref1;
        return (ref1 = variant.accessoryColor) === null || ref1 === void 0 ? void 0 : ref1.localized;
    }
    if (productType === 'Solutions') {
        const volume = variant.packageOption;
        return `${volume}`;
    }
};

export { getVariantFacetName };
//# sourceMappingURL=utils.js.map
